import { Exceptiondt2hlxn7j7vw as Exception } from '../exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CharacterCodingExceptionClass;
function CharacterCodingException() {
  if (CharacterCodingExceptionClass === VOID) {
    class $ extends Exception() {
      constructor(message) {
        return new.target.new_kotlin_text_CharacterCodingException_wozcvs_k$(message);
      }
      static new_kotlin_text_CharacterCodingException_wozcvs_k$(message) {
        var $this = this.new_kotlin_Exception_hsqbop_k$(message);
        captureStack($this, $this.$throwableCtor_2);
        return $this;
      }
      static new_kotlin_text_CharacterCodingException_el5v5_k$() {
        return this.new_kotlin_text_CharacterCodingException_wozcvs_k$(null);
      }
    }
    initMetadataForClass($, 'CharacterCodingException', $.new_kotlin_text_CharacterCodingException_el5v5_k$);
    CharacterCodingExceptionClass = $;
  }
  return CharacterCodingExceptionClass;
}
//region block: exports
export {
  CharacterCodingException as CharacterCodingException3mvgnmpleqbz9,
};
//endregion

//# sourceMappingURL=CharacterCodingExceptionJs.mjs.map
